<template>
    <div :class="inputclass">
      <img :src="icon" alt="">
      <input :type="types" :placeholder="tips">
    </div>
</template>

<script>
    export default {
        name: "Input",
        props:{
          types:{
            type:String,
            default:'text'
          },
          tips:{
            type:String,
            default:'默认提示'
          },
          inputclass:{
            type:String,
            default:'login'
          },
          icon:{
            type:String,
            default:'/static/img/phone.png'
          }
        }
    }
</script>

<style scoped lang="less">
  .login{
    display: flex;
    justify-content: space-around;
    img{
      /*padding-bottom: 10px;*/
      width: 24px;
      height: 32px;
    }
    input{
      border: none;
      font-size: 0.3rem;
      border-bottom: 1px solid #e8e8e8;
      width: 80%;
      /*margin-left: 10%;*/
      &:focus{
        border-color: #22bb61;
      }
      &::placeholder{
        color: #7c7c7c;
      }
    }
  }
  .register{
    /*display: flex;*/
    /*justify-content: space-around;*/
    position: relative;
    img{
      position: absolute;
      width: 24px;
      height: 32px;
      bottom: 10px;
    }
    input{
      border: none;
      font-size: 0.3rem;
      border-bottom: 1px solid #e8e8e8;
      width: 100%;
      /*margin-left: 10%;*/
      padding-left: 15%;
      height: 36px;
      &:focus{
        border-color: #22bb61;
      }
      &::placeholder{
        color: #7c7c7c;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/assembly/Input/Input.vue